import React from "react";
import { List } from "../modules/Sites";

export function SitesListPage(props) {
  return <List {...props} />;
}
